export class I18n {
  /**
   * headline on top of the layer. Placeholders: carlineName, salesGroupNames, trimNames
   *
   * */
  'layer.headline'?: string = 'Technical Data';
  /**
   * aria-label attribute for the layer close button.
   *
   * */
  'layer.closebutton.aria.label'?: string = 'close';
  /**
   * title for metadata (used for SEO). Placeholders: carlineName, salesGroupNames, trimNames.
   *
   * */
  'metadata.title'?: string = undefined;
  /**
   * description for metadata (used for SEO). Placeholders: carlineName, salesGroupNames, trimNames.
   *
   * */
  'metadata.description'?: string = undefined;
  /**
   * headline in bold in the header. Placeholders: carlineName, salesGroupNames, trimNames
   *
   * */
  'header.headline'?: string = undefined;
  /**
   * headline extension in the header. Placeholders: carlineName, salesGroupNames, trimNames
   *
   * */
  'header.headlineExtension'?: string = undefined;
  /**
   * headline text for the no-data-layer.
   *
   * */
  'nodata.headline'?: string = 'Something went wrong!';
  /**
   * copy text for the no-data-layer.
   *
   * */
  'nodata.copy'?: string =
    'Currently we cannot show you the requested data. We are working on it. Please have a look again to a later point of time.';
  /**
   * label of the group for wltp data
   *
   * */
  'group.wltp.label'?: string = 'EMISSION AND CONSUMPTION';
  /**
   * label of the wltp data for consumtion combined
   *
   * */
  'group.wltp.consumption.combined.label'?: string = 'consumption combined';
  /**
   * label of the wltp data for consumtion extra hight
   *
   * */
  'group.wltp.consumption.extra_high.label'?: string = 'consumption extra high';
  /**
   * label of the wltp data for consumtion high
   *
   * */
  'group.wltp.consumption.high.label'?: string = 'consumption high';
  /**
   * label of the wltp data for consumtion medium
   *
   * */
  'group.wltp.consumption.medium.label'?: string = 'consumption medium';
  /**
   * label of the wltp data for consumtion low
   *
   * */
  'group.wltp.consumption.low.label'?: string = 'consumption low';
  /**
   * label of the wltp data for emission combined
   *
   * */
  'group.wltp.co2.combined.label'?: string = 'emission combined';
  /**
   * label of the wltp data for emission extra high
   *
   * */
  'group.wltp.co2.extra_high.label'?: string = 'emission extra high';
  /**
   * label of the wltp data for emission high
   *
   * */
  'group.wltp.co2.high.label'?: string = 'emission high';
  /**
   * label of the wltp data for emission medium
   *
   * */
  'group.wltp.co2.medium.label'?: string = 'emission medium';
  /**
   * label of the wltp data for emission low
   *
   * */
  'group.wltp.co2.low.label'?: string = 'emission low';
  /**
   * label of the wltp data for electric range city
   *
   * */
  'group.wltp.range.city.label'?: string = 'electric range city';
  /**
   * label of the wltp data for electric range combined
   *
   * */
  'group.wltp.range.combined.label'?: string = 'electric range combined';
  /**
   * label of the wltp data for electric range extra high
   *
   * */
  'group.wltp.range.extra_high.label'?: string = 'electric range extra high';
  /**
   * label of the wltp data for electric range high
   *
   * */
  'group.wltp.range.high.label'?: string = 'electric range high';
  /**
   * label of the wltp data for electric range medium
   *
   * */
  'group.wltp.range.medium.label'?: string = 'electric range medium';
  /**
   * label of the wltp data for electric range low
   *
   * */
  'group.wltp.range.low.label'?: string = 'electric range low';
  /**
   * label of the wltp data for energy efficiency class
   * */
  'group.wltp.energyEfficiency.label'?: string = 'efficiency class';
  /**
   * aria-label attribute for the disclaimer ref badge
   *
   * */
  'disclaimer.badge.aria.label'?: string = 'Show disclaimer nr.';
  /**
   * wltp disclaimer text for electric range
   *
   * */
  'disclaimer.wltp.electricRange.text'?: string =
    'disclaimer for electric range';
  /**
   * wltp disclaimer text for consumption
   *
   * */
  'disclaimer.wltp.consumption.text'?: string = 'disclaimer for consumption';
  /**
   * wltp disclaimer text for emission
   *
   * */
  'disclaimer.wltp.emission.text'?: string = 'disclaimer for emission';
  /**
   * wltp disclaimer text for energy efficiency class
   * */
  'disclaimer.wltp.energyEfficiency.text'?: string =
    'disclaimer for energy efficiency class';
  /**
   * disclaimer for images
   * */
  'disclaimer.images.label'?: string =
    'The vehicle illustration shows {carlineName} {salesgroupName} {trimName}.';

  // *** model filters ***
  /**
   * label for model filter EnginePower
   * */
  'modelFilter.EnginePower.label'?: string = undefined;
  /**
   * label for model filter SystemPowerKW
   * */
  'modelFilter.SystemPowerKW.label'?: string = undefined;
  /**
   * label for model filter Engine_2
   * */
  'modelFilter.Engine_2.label'?: string = undefined;
  /**
   * label for model filter FuelType
   * */
  'modelFilter.FuelType.label'?: string = undefined;
  /**
   * label for model filter Gear
   * */
  'modelFilter.Gear.label'?: string = undefined;
  /**
   * label for model filter EquipmentLine
   * */
  'modelFilter.EquipmentLine.label'?: string = undefined;
  /**
   * label for model filter SystemPowerPS
   * */
  'modelFilter.SystemPowerPS.label'?: string = undefined;
  /**
   * label for model filter EngineTypeAttribute1
   * */
  'modelFilter.EngineTypeAttribute1.label'?: string = undefined;
  /**
   * label for model filter Wheelbase
   * */
  'modelFilter.Wheelbase.label'?: string = undefined;
  /**
   * label for model filter EngineType
   * */
  'modelFilter.EngineType.label'?: string = undefined;
  /**
   * label for model filter Drive
   * */
  'modelFilter.Drive.label'?: string = undefined;
  /**
   * label for model filter GrossVehicleWeight
   * */
  'modelFilter.GrossVehicleWeight.label'?: string = undefined;
  /**
   * label for model filter RoofType
   * */
  'modelFilter.RoofType.label'?: string = undefined;
  /**
   * label for model filter Overhang
   * */
  'modelFilter.Overhang.label'?: string = undefined;
  /**
   * label for model filter EnginePower2
   * */
  'modelFilter.EnginePower2.label'?: string = undefined;
  /**
   * label for model filter Transmission
   * */
  'modelFilter.Transmission.label'?: string = undefined;
  /**
   * label for model filter Capacity
   * */
  'modelFilter.Capacity.label'?: string = undefined;
  /**
   * label for model filter Engine
   * */
  'modelFilter.Engine.label'?: string = undefined;
  /**
   * label for model filter EngineUnitPs
   * */
  'modelFilter.EngineUnitPs.label'?: string = undefined;
  /**
   * label for model filter EngineUnitKw
   * */
  'modelFilter.EngineUnitKw.label'?: string = undefined;
  /**
   * label for model filter EnginePower4
   * */
  'modelFilter.EnginePower4.label'?: string = undefined;
  /**
   * label for model filter EnginePower3
   * */
  'modelFilter.EnginePower3.label'?: string = undefined;
  /**
   * label for model filter EngineTypeAttribute2
   * */
  'modelFilter.EngineTypeAttribute2.label'?: string = undefined;
  /**
   * label for model filter Torque
   * */
  'modelFilter.Torque.label'?: string = undefined;
  /**
   * label for model filter Topspeed
   * */
  'modelFilter.Topspeed.label'?: string = undefined;
  /**
   * label for model filter Emission
   * */
  'modelFilter.Emission.label'?: string = undefined;
  /**
   * label for model filter Consumption
   * */
  'modelFilter.Consumption.label'?: string = undefined;
  /**
   * label for model filter DurationOfCharge
   * */
  'modelFilter.DurationOfCharge.label'?: string = undefined;
  /**
   * label for model filter ChargingTime
   * */
  'modelFilter.ChargingTime.label'?: string = undefined;
  /**
   * label for model filter NumberOfDoors
   * */
  'modelFilter.NumberOfDoors.label'?: string = undefined;
  /**
   * label for model filter TorqueRPM
   * */
  'modelFilter.TorqueRPM.label'?: string = undefined;
  /**
   * label for model filter FiscalPower
   * */
  'modelFilter.FiscalPower.label'?: string = undefined;

  // *** PHEV (engineType OVC_HEV): Germany's WLTP legislation PKW EnVKV requires specific WLTP representation ***
  /**
   * label of the wltp data for PHEV consumtion combined weighted
   * */
  'group.wltp.phev.consumption.combined.weighted.label'?: string =
    'consumption combined weighted';
  /**
   * label of the wltp data for PHEV consumtion combined empty battery
   * */
  'group.wltp.phev.consumption.combined.emptyBattery.label'?: string =
    'consumption combined empty battery';
  /**
   * label of the wltp data for PHEV consumtion extra high empty battery
   * */
  'group.wltp.phev.consumption.extra_high.emptyBattery.label'?: string =
    'consumption extra high empty battery';
  /**
   * label of the wltp data for PHEV consumtion high empty battery
   * */
  'group.wltp.phev.consumption.high.emptyBattery.label'?: string =
    'consumption high empty battery';
  /**
   * label of the wltp data for PHEV consumtion medium empty battery
   * */
  'group.wltp.phev.consumption.medium.emptyBattery.label'?: string =
    'consumption medium empty battery';
  /**
   * label of the wltp data for PHEV consumtion low empty battery
   * */
  'group.wltp.phev.consumption.low.emptyBattery.label'?: string =
    'consumption low empty battery';
  /**
   * label of the wltp data for PHEV emission combined weighted
   * */
  'group.wltp.phev.co2.combined.weighted.label'?: string =
    'emission combined weighted';
  /**
   * label of the wltp data for PHEV emission combined empty battery
   * */
  'group.wltp.phev.co2.combined.emptyBattery.label'?: string =
    'emission combined empty battery';
  /**
   * label of the wltp data for PHEV emission extra high empty battery
   * */
  'group.wltp.phev.co2.extra_high.emptyBattery.label'?: string =
    'emission extra high empty battery';
  /**
   * label of the wltp data for PHEV emission high empty battery
   * */
  'group.wltp.phev.co2.high.emptyBattery.label'?: string =
    'emission high empty battery';
  /**
   * label of the wltp data for PHEV emission medium empty battery
   * */
  'group.wltp.phev.co2.medium.emptyBattery.label'?: string =
    'emission medium empty battery';
  /**
   * label of the wltp data for PHEV emission low empty battery
   * */
  'group.wltp.phev.co2.low.emptyBattery.label'?: string =
    'emission low empty battery';
  /**
   * label of the wltp data for PHEV energy efficiency class weighted
   * */
  'group.wltp.phev.energyEfficiency.weighted.label'?: string =
    'efficiency class weighted';
  /**
   * label of the wltp data for PHEV energy efficiency class empty battery
   * */
  'group.wltp.phev.energyEfficiency.emptyBattery.label'?: string =
    'efficiency class empty battery';
  /**
   * value template of the wltp data for PHEV consumtion weighted
   * */
  'group.wltp.phev.consumption.weighted.value.template'?: string =
    '{ELECTRIC} plus {COMBUSTION}';

  // *** FILTERS ***
  /**
   * label for filter trim
   * */
  'filters.trim.label'?: string = undefined;
  /**
   * label for default option
   * */
  'filters.trim.defaultOption.label'?: string = undefined;
}
export type I18nKey = keyof I18n;
